import { Suspense } from "react";
import { Await, useLoaderData, useOutlet } from "react-router-dom";
import { AppProvider } from "../../contexts/AppContext";
import { properties } from "../../utils/Properties_es";
import Loading from "../utils/Loading";
/*****************************************************************************
 * REVISION 1.0
 * Fecha: 06/06/2024
 *
 * @description componente template - authorization
 * @author luis.ferrer
 * @version 1.0
 *
 ****************************************************************************/
export const AuthLayout = () => {
  const outlet = useOutlet();

  const { authPromise } = useLoaderData();

  return (
    <Suspense
      fallback={<Loading title={properties.com_sinpepay_label_loading_title} />}
    >
      <Await
        resolve={authPromise}
        children={(authObject) => (
          <AppProvider authData={authObject?.authInfo} authOptionData={authObject?.authOption}>{outlet}</AppProvider>
        )}
      />
    </Suspense>
  );
};
